import moment from 'moment-timezone';

export default function formatDate(dateFrom, dateTo, timezone) {

  if (!dateFrom) return;

  const from = moment(dateFrom).tz(timezone);
  const to = dateTo ? moment(dateTo).tz(timezone) : '';
  const dayDiffSeperator = to && to.diff(from, 'days') > 1 ? '&' : '-';

  const dateFromDay = from.format('DD');
  const dateFromMonth = from.format('MMMM');
  const dateFromYear = from.format('YYYY');

  const dateToDay = to ? to.format('DD') : '';
  const dateToMonth = to ? to.format('MMMM') : '';
  const dateToYear = to ? to.format('YYYY') : '';

  const isSameDay = dateFromDay === dateToDay;
  const isSameMonth = dateFromMonth === dateToMonth;
  const isSameYear = dateFromYear === dateToYear;

  if (isSameDay && isSameMonth && isSameYear) {
    return `${dateFromMonth} ${dateFromDay}, ${dateFromYear}`;
  }



  const formatToDate = dateToDay || dateToMonth || dateToYear ? ` ${dayDiffSeperator} ${dateToMonth} ${dateToDay}, ${dateToYear}` : '';

  if (isSameMonth && isSameYear) {
    return ` ${dateToMonth} ${dateFromDay} ${dayDiffSeperator} ${dateToDay}, ${dateToYear}` ;
  }

  if (isSameYear) {
    return `${dateFromMonth} ${dateFromDay}${formatToDate}`;
  }

  return `${dateFromMonth} ${dateFromDay} ${dateFromYear}${formatToDate}`;
}

